import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import styled, { ThemeContext } from 'styled-components';
import {
  FormContext, Article, Title, HelpBlock, Input, Button, ReflowContainer, InputContainer,
} from '../form-context';
import Loading from '../../../../shared/loading';
import { useForm } from '../../../../shared/form-validator-hook';
import { usePostCmSubscribe } from '../../../../services/campaign-mailist-service';

const Div = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export default function EmailForm({ ebookName }) {
  const { state, dispatch } = React.useContext(FormContext);
  const { isPortrait } = React.useContext(ThemeContext);
  const {
    values, useInput, isValid, errors,
  } = useForm({ email: '' });
  const [{ response, loading }, subscribe] = usePostCmSubscribe();
  const loadingRef = React.useRef();

  React.useEffect(() => loadingRef.current && loadingRef.current.toggle(loading), [loading]);

  React.useEffect(() => {
    if (_.get(response, 'status') === 204) {
      dispatch({ type: 'setEmail', payload: values.email });
      dispatch({ type: 'stepToDownload' });
    }
  }, [response, values.email, dispatch]);

  function submit(e) {
    e.preventDefault();
    if (isValid) {
      subscribe(values);
    }
  }

  return (
    <Article name="form" short>
      {isPortrait
        ? (
          <Title>
            {`Hi ${state.firstName}, enter the email you’d like us to send your `}
            <em>{ebookName}</em>
            {' book'}
          </Title>
        )
        : (
          <Div>
            <Title>
              {`Hi ${state.firstName}, enter the email you’d like us to`}
            </Title>
            <Title>
              {'send your '}
              <em>{ebookName}</em>
              {' ebook'}
            </Title>
          </Div>
        )}
      <ReflowContainer short>
        <InputContainer>
          <Input
            type="text"
            placeholder="email"
            {...useInput('email', 'isRequired, isEmail')}
          />
          {errors.email && (
          <HelpBlock>
            {{
              isRequired: 'Email address is required',
              isEmail: 'Email address is invalid',
            }[errors.email]}
          </HelpBlock>
          )}
        </InputContainer>
      </ReflowContainer>
      <Loading variant="button" ref={loadingRef}>
        <Button onClick={submit} disabled={!isValid}>access my ebook</Button>
      </Loading>
    </Article>
  );
}

EmailForm.propTypes = {
  ebookName: PropTypes.string.isRequired,
};
